import { render } from "./HelpVdol.vue?vue&type=template&id=01d4a2b8&scoped=true"
import script from "./HelpVdol.vue?vue&type=script&lang=js"
export * from "./HelpVdol.vue?vue&type=script&lang=js"

import "./HelpVdol.vue?vue&type=style&index=0&id=01d4a2b8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01d4a2b8"]])

export default __exports__